// SEO config for each city landing page.
// Each config drives H1, meta, JSON-LD Service + FAQ schema, and neighborhood mentions.

const IMG_LVP_DINING =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_hardscape-pro-5/artifacts/paytz0q5_IMG_8223.jpeg";
const IMG_LVP_FAMILY =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_hardscape-pro-5/artifacts/ipk2asyx_IMG_8221.jpeg";
const IMG_LVP_FIREPLACE =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_hardscape-pro-5/artifacts/xo198ivi_IMG_8222.jpeg";
const IMG_LVP_COMMERCIAL =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_hardscape-pro-5/artifacts/oo6v3oj1_IMG_8220.jpeg";
const IMG_MARBLE_BATH =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_hardscape-pro-5/artifacts/x7m4cm17_IMG_8219.jpeg";
const IMG_TILE_HEX =
  "https://customer-assets.emergentagent.com/job_hardscape-pro-5/artifacts/9z6zytzm_IMG_7768.jpeg";
const IMG_TILE_MARBLE =
  "https://customer-assets.emergentagent.com/job_hardscape-pro-5/artifacts/5fuiwjzx_IMG_7766.jpeg";
const IMG_LVP_BASEMENT =
  "https://customer-assets.emergentagent.com/job_hardscape-pro-5/artifacts/ud9ci9kn_2F372B81-94D2-480F-B9D3-8B7BE4993A4D.png";
const IMG_LAMINATE_KITCHEN =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_hardscape-pro-5/artifacts/4wknacka_IMG_8732.jpeg";
const IMG_HERRINGBONE =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_hardscape-pro-5/artifacts/bd1eb7qe_IMG_8258.jpeg";

const BASE_SERVICES = [
  {
    title: "LVP Flooring Installation",
    copy: "100% waterproof luxury vinyl plank — perfect for basements, kitchens, bathrooms, and family rooms. Wood-look finishes, kid & pet friendly.",
    image: IMG_LVP_BASEMENT,
  },
  {
    title: "Laminate Flooring Installation",
    copy: "The look of hardwood at a fraction of the cost. Extra-hard wear layer resists scratches, fading, and daily traffic.",
    image: IMG_LAMINATE_KITCHEN,
  },
  {
    title: "Tile Installation",
    copy: "Hex, marble-look, herringbone, and large-format porcelain. Every cut scored on-site for tight grout and flush transitions.",
    image: IMG_TILE_HEX,
  },
  {
    title: "Flooring Removal & Tear-Out",
    copy: "Carpet, old laminate, glued-down vinyl, cracked tile — full tear-out, subfloor leveling, and haul-away included.",
    image: IMG_LVP_COMMERCIAL,
  },
  {
    title: "Baseboards & Trim Finishing",
    copy: "Modern flat or profiled traditional baseboards, shoe molding, and quarter round — mitered, caulked, and painted.",
    image: IMG_HERRINGBONE,
  },
  {
    title: "Bathroom & Kitchen Tile",
    copy: "Waterproof shower walls, backsplashes, and full bathroom tile installs — marble, ceramic, and porcelain.",
    image: IMG_MARBLE_BATH,
  },
];

export const OFALLON_CONFIG = {
  slug: "ofallon-mo",
  city: "O'Fallon",
  county: "St. Charles County",
  zips: ["63366", "63368"],
  heroKicker: "Owner-Operated · Based in O'Fallon, MO",
  heroImage: IMG_LVP_FAMILY,
  neighborhoods: [
    "Winghaven",
    "Dardenne Creek",
    "Boschertown",
    "Bryan Estates",
    "Villages of Dardenne",
    "Whitmoor",
    "Lake Saint Louise",
    "Fairway Estates",
    "Persimmon Woods",
    "Autumn Ridge",
    "Waterbury Estates",
    "Twin Chimneys",
  ],
  localCopy: [
    "M&L Exterior and Interior Design is based right here in O'Fallon, MO — with over a decade of flooring installs across every subdivision from Winghaven and Whitmoor to Twin Chimneys and Villages of Dardenne. As your neighbors, we know the moisture and slab conditions in O'Fallon basements, and we prep every subfloor accordingly.",
    "Whether you're upgrading a family home near WingHaven Country Club, refreshing a kitchen in the Villages of Dardenne, or finishing a new-build basement off Bryan Road, we handle LVP, laminate, tile, complete flooring removal, and baseboard trim — start to finish with the same crew.",
  ],
  services: BASE_SERVICES,
  galleryImages: [
    { image: IMG_LVP_FAMILY, title: "Light-Oak LVP Family Room", type: "LVP · O'Fallon" },
    { image: IMG_LVP_COMMERCIAL, title: "Gray LVP Office Buildout", type: "Commercial LVP · O'Fallon" },
    { image: IMG_LVP_BASEMENT, title: "Wide-Plank Basement Install", type: "LVP · O'Fallon" },
  ],
  faqs: [
    {
      q: "Do you offer flooring installation in O'Fallon, MO?",
      a: "Yes — M&L Exterior and Interior Design is based in O'Fallon and serves every subdivision in the 63366 and 63368 ZIP codes, including Winghaven, Whitmoor, Villages of Dardenne, Twin Chimneys, Bryan Estates, and Autumn Ridge. We install LVP, laminate, tile, and handle complete flooring removal and baseboard trim.",
    },
    {
      q: "How much does flooring installation cost in O'Fallon?",
      a: "Labor typically ranges from $3–$6 per sq ft for LVP and laminate, and $7–$12 per sq ft for tile — depending on subfloor prep, layout, and pattern complexity. Every O'Fallon quote is a transparent, line-item written estimate after a free on-site walkthrough.",
    },
    {
      q: "Do you install LVP in O'Fallon basements?",
      a: "Yes — waterproof LVP is our most-requested basement flooring in O'Fallon. We level and moisture-seal the concrete slab first, then install click-lock or glue-down LVP with tight seams and clean transitions at stairs and doorways.",
    },
    {
      q: "How soon can you start a flooring project in O'Fallon?",
      a: "Because we're local to O'Fallon, we can typically schedule a free on-site quote within 24–48 hours. Most single-room installs start within 1–2 weeks of quote acceptance.",
    },
  ],
};

export const WENTZVILLE_CONFIG = {
  slug: "wentzville-mo",
  city: "Wentzville",
  county: "St. Charles County",
  zips: ["63385"],
  heroKicker: "Serving Wentzville · Foristell · Lake Saint Louis",
  heroImage: IMG_MARBLE_BATH,
  neighborhoods: [
    "Bear Creek",
    "Stone Meadows",
    "Bryan Woods",
    "Wilmer Valley",
    "Peruque Hills",
    "Heartland Park",
    "Bear Creek Farms",
    "Legends at Schroeder Farms",
    "Meadowbrook Farms",
    "Timber Creek",
    "Persimmon Ridge",
    "Fiddle Creek",
  ],
  localCopy: [
    "Wentzville is one of the fastest-growing communities in Missouri — and we've been installing flooring here since long before the new subdivisions arrived. From new builds in Bear Creek and Stone Meadows to established homes in Wilmer Valley and Peruque Hills, we've become the go-to Wentzville flooring contractor for LVP, laminate, tile, flooring removal, and baseboard finishing.",
    "Because Wentzville homes span new construction to older ranches, we tailor every subfloor prep to what's under your existing floor — whether it's a slab, plywood, or original hardwood. Same owner on the quote, same crew on install day.",
  ],
  services: BASE_SERVICES,
  galleryImages: [
    { image: IMG_MARBLE_BATH, title: "Calacatta Marble Primary Bath", type: "Tile · Wentzville" },
    { image: IMG_LAMINATE_KITCHEN, title: "Dark Hardwood-Look Kitchen", type: "Laminate · Wentzville" },
    { image: IMG_LVP_DINING, title: "Weathered-Oak Dining Room", type: "LVP · Wentzville" },
  ],
  faqs: [
    {
      q: "Do you install flooring in Wentzville, MO (63385)?",
      a: "Yes — Wentzville is one of our most-served communities. We install LVP, laminate, and tile flooring in every 63385 subdivision, including Bear Creek, Stone Meadows, Wilmer Valley, Persimmon Ridge, and Legends at Schroeder Farms.",
    },
    {
      q: "What's the best flooring for a Wentzville new build?",
      a: "Most Wentzville new builds are best suited to waterproof LVP on the main level and basement, with tile in bathrooms and mudrooms. We can walk your home during framing or after move-in and recommend the best material based on subfloor, moisture, and layout.",
    },
    {
      q: "Do you install tile bathrooms in Wentzville?",
      a: "Yes — bathroom tile is one of our specialties in Wentzville. Waterproof shower walls, marble-look large-format flooring, herringbone patterns, and full bathroom remodels are all handled in-house.",
    },
    {
      q: "How long does a Wentzville flooring install take?",
      a: "Most single-room LVP or laminate installs finish in 1–2 days. Full main-level installs across a Wentzville home usually run 3–5 working days. Bathroom tile typically takes 3–5 days depending on shower complexity.",
    },
  ],
};

export const CHESTERFIELD_CONFIG = {
  slug: "chesterfield-mo",
  city: "Chesterfield",
  county: "St. Louis County",
  zips: ["63005", "63017", "63006"],
  heroKicker: "Premium Installs Across West County",
  heroImage: IMG_TILE_MARBLE,
  neighborhoods: [
    "Wildhorse",
    "Chesterfield Valley",
    "Bellerive Country Club",
    "Kehrs Mill Trails",
    "Windrush Creek",
    "Baxter Ridge",
    "Chesterfield Farms",
    "Hilltop",
    "Highcroft Ridge",
    "River Bend",
    "Baxter Estates",
    "White Road",
  ],
  localCopy: [
    "Chesterfield homeowners expect premium finishes — and we've spent over a decade earning our reputation as one of West County's most trusted flooring contractors. From Wildhorse and Kehrs Mill Trails to Bellerive and Windrush Creek, we've installed LVP, laminate, and large-format tile in some of Chesterfield's most beautiful homes.",
    "In Chesterfield, we frequently pair marble-look large-format tile in primary baths with wide-plank LVP or laminate across the main level — a combination that reads high-end without the maintenance of real hardwood. Every install includes complete tear-out, subfloor leveling, and baseboard finishing.",
  ],
  services: BASE_SERVICES,
  galleryImages: [
    { image: IMG_TILE_MARBLE, title: "Marble-Look Living Room Tile", type: "Large-Format Tile · Chesterfield" },
    { image: IMG_LVP_FIREPLACE, title: "Espresso LVP Living Room", type: "LVP · Chesterfield" },
    { image: IMG_HERRINGBONE, title: "Herringbone Tile Foyer", type: "Custom Tile · Chesterfield" },
  ],
  faqs: [
    {
      q: "Do you install flooring in Chesterfield, MO?",
      a: "Yes — we serve all of Chesterfield including the 63005, 63017, and 63006 ZIP codes. Popular areas we install in: Wildhorse, Kehrs Mill Trails, Bellerive Country Club, Chesterfield Farms, Baxter Ridge, and Highcroft Ridge.",
    },
    {
      q: "What's the best flooring for a Chesterfield home?",
      a: "Most Chesterfield homeowners choose wide-plank waterproof LVP or premium laminate for main levels, paired with large-format marble-look porcelain in primary baths and kitchens. We tailor the selection to the home's style — from Wildhorse contemporary to Bellerive traditional.",
    },
    {
      q: "Do you handle high-end tile bathrooms in Chesterfield?",
      a: "Yes — premium tile bathrooms are one of our specialties in Chesterfield. Marble-look large-format porcelain, custom shower niches, herringbone floor patterns, and full tile-to-ceiling walls — all cut and set on-site for tight, uniform grout lines.",
    },
    {
      q: "Are you licensed and insured for Chesterfield projects?",
      a: "Yes — fully licensed and insured in Missouri. We're happy to share our insurance certificate before any Chesterfield project starts. Family-owned since 2013, based in O'Fallon, MO.",
    },
  ],
};

export const KIRKWOOD_CONFIG = {
  slug: "kirkwood-mo",
  city: "Kirkwood",
  county: "St. Louis County",
  zips: ["63122"],
  heroKicker: "Historic Homes · Modern Floors",
  heroImage: IMG_LVP_FIREPLACE,
  neighborhoods: [
    "Downtown Kirkwood",
    "Meacham Park",
    "Sugar Creek",
    "Osage Hills",
    "Greentree",
    "Fillmore Estates",
    "Grantwood Village",
    "Oakwood",
    "Warson Woods",
    "Craig Park",
    "Ridge Meadows",
    "Kirkwood Farms",
  ],
  localCopy: [
    "Kirkwood is one of St. Louis County's most historic communities — and installing floors here means respecting original character while modernizing what's underneath. From craftsman bungalows near Downtown Kirkwood to family homes in Greentree and Osage Hills, we specialize in fitting new LVP, laminate, and tile into houses with original hardwood, uneven subfloors, and vintage layouts.",
    "Kirkwood homeowners often choose wide-plank laminate or waterproof LVP for main floors, with hex or subway tile in primary baths and kitchens. Every install includes complete tear-out (carpet, old vinyl, cracked tile), subfloor leveling, moisture sealing, and baseboard finishing.",
  ],
  services: BASE_SERVICES,
  galleryImages: [
    { image: IMG_LVP_FIREPLACE, title: "Espresso LVP Living Room", type: "LVP · Kirkwood" },
    { image: IMG_TILE_HEX, title: "Hex-Tile Primary Bath", type: "Tile · Kirkwood" },
    { image: IMG_LAMINATE_KITCHEN, title: "Wood-Look Laminate Kitchen", type: "Laminate · Kirkwood" },
  ],
  faqs: [
    {
      q: "Do you install flooring in Kirkwood, MO (63122)?",
      a: "Yes — Kirkwood is one of our most-served St. Louis County communities. We install LVP, laminate, and tile in every 63122 neighborhood including Downtown Kirkwood, Greentree, Osage Hills, Sugar Creek, and Meacham Park.",
    },
    {
      q: "Can you install over the original hardwood in older Kirkwood homes?",
      a: "In most cases we recommend removing the original hardwood first so we can level and seal the subfloor properly — especially in homes 50+ years old where cupping and squeaking are common. We handle the tear-out and haul-away as part of every quote.",
    },
    {
      q: "What flooring works best in a Kirkwood bungalow?",
      a: "For classic Kirkwood bungalows we usually recommend a mid-tone wide-plank LVP or premium laminate for the main floor to complement original woodwork, and hex or subway tile in the primary bath to match the era of the home.",
    },
  ],
};

export const BALLWIN_CONFIG = {
  slug: "ballwin-mo",
  city: "Ballwin",
  county: "St. Louis County",
  zips: ["63011", "63021", "63022"],
  heroKicker: "Family Homes · West County",
  heroImage: IMG_LVP_FAMILY,
  neighborhoods: [
    "Ballwin Golf Estates",
    "Twin Oaks",
    "Kehrs Mill",
    "Meramec Estates",
    "Countryhaven",
    "Westglen Farms",
    "Ballwin Ridge",
    "Chapel Hill",
    "Fair Oaks",
    "Fox Creek",
    "New Ballwin",
    "Ballwin Heights",
  ],
  localCopy: [
    "Ballwin is a family-first West County community — and we've become the go-to Ballwin flooring contractor for busy homeowners who want durable, kid- and pet-friendly floors. From Ballwin Golf Estates to Kehrs Mill and Twin Oaks, we install waterproof LVP, premium laminate, and tile in homes across every 63011, 63021, and 63022 subdivision.",
    "Ballwin's mix of older 1980s builds and newer construction means we often handle full-home flooring replacements — carpet-to-LVP conversions, basement tear-outs, and kitchen tile refreshes. Every project ships with tight subfloor prep, baseboard finishing, and a workmanship guarantee.",
  ],
  services: BASE_SERVICES,
  galleryImages: [
    { image: IMG_LVP_FAMILY, title: "Light-Oak LVP Family Room", type: "LVP · Ballwin" },
    { image: IMG_LVP_BASEMENT, title: "Wide-Plank Basement LVP", type: "LVP · Ballwin" },
    { image: IMG_TILE_HEX, title: "Hex-Tile Bathroom", type: "Tile · Ballwin" },
  ],
  faqs: [
    {
      q: "Do you install flooring in Ballwin, MO?",
      a: "Yes — we serve every Ballwin ZIP: 63011, 63021, and 63022. Popular subdivisions we work in include Ballwin Golf Estates, Twin Oaks, Kehrs Mill, Meramec Estates, and Countryhaven.",
    },
    {
      q: "How much does LVP flooring cost in Ballwin?",
      a: "Labor runs $3–$6 per sq ft for LVP installs in Ballwin, plus materials. A typical 1,000 sq ft main-level install is $3,500–$7,000 installed depending on materials, prep, and transitions.",
    },
    {
      q: "Do you do carpet-to-LVP conversions in Ballwin?",
      a: "Yes — carpet-to-LVP is one of our most common Ballwin projects. We handle complete carpet, padding, and tack-strip removal, subfloor leveling, and full LVP install plus baseboards.",
    },
  ],
};

export const STPETERS_CONFIG = {
  slug: "st-peters-mo",
  city: "St. Peters",
  county: "St. Charles County",
  zips: ["63304", "63376"],
  heroKicker: "Serving All of St. Peters",
  heroImage: IMG_LVP_DINING,
  neighborhoods: [
    "Willot",
    "Country Hill Estates",
    "Cottleville Trails",
    "Mid Rivers",
    "Executive Estates",
    "St. Peters Golf Club",
    "Spencer Creek",
    "Suemandy Heights",
    "The Hamptons",
    "Regency Park",
    "Old Town St. Peters",
    "Salt River Ridge",
  ],
  localCopy: [
    "St. Peters is right in our backyard — a short drive from our O'Fallon shop, and one of our top-served St. Charles County communities. We install LVP, laminate, and tile across every 63304 and 63376 neighborhood from Willot and Mid Rivers to Executive Estates and Country Hill.",
    "Whether you're upgrading a mid-90s ranch off Mexico Road or finishing a new-build basement in the Hamptons, we bring the same level, seam-tight, transition-clean install to every St. Peters home — with a workmanship guarantee that has us coming back if anything ever moves.",
  ],
  services: BASE_SERVICES,
  galleryImages: [
    { image: IMG_LVP_DINING, title: "Weathered-Oak LVP Dining", type: "LVP · St. Peters" },
    { image: IMG_LVP_FIREPLACE, title: "Espresso LVP Living Room", type: "LVP · St. Peters" },
    { image: IMG_HERRINGBONE, title: "Herringbone Tile Foyer", type: "Custom Tile · St. Peters" },
  ],
  faqs: [
    {
      q: "Do you install flooring in St. Peters, MO (63304 & 63376)?",
      a: "Yes — St. Peters is one of our top-served communities. We install LVP, laminate, and tile in every 63304 and 63376 subdivision including Willot, Mid Rivers, Executive Estates, Country Hill, Spencer Creek, and The Hamptons.",
    },
    {
      q: "How quickly can you start a St. Peters project?",
      a: "Because we're based in nearby O'Fallon, we can typically schedule a free on-site St. Peters quote within 24–48 hours. Most installs start within 1–2 weeks of quote acceptance.",
    },
    {
      q: "Do you install LVP in St. Peters basements?",
      a: "Yes — waterproof LVP is our top pick for St. Peters basements. We level the slab, install a moisture barrier, and lay wide-plank LVP with clean stair transitions.",
    },
  ],
};

export const STCHARLES_CONFIG = {
  slug: "st-charles-mo",
  city: "St. Charles",
  county: "St. Charles County",
  zips: ["63301", "63303", "63304"],
  heroKicker: "Historic Homes & New Builds",
  heroImage: IMG_LVP_DINING,
  neighborhoods: [
    "Historic Main Street",
    "Frenchtown",
    "Bogey Hills",
    "Piper Hills",
    "Old Town St. Charles",
    "Elm Point",
    "Wildwood",
    "Willowbrook Estates",
    "Country Club Village",
    "Muegge Farms",
    "Kingshighway",
    "Hunter's Glen",
  ],
  localCopy: [
    "The City of St. Charles is a fascinating mix — 19th-century brick homes on Historic Main Street and Frenchtown next to modern subdivisions in Bogey Hills and Piper Hills. We've installed flooring across every era of St. Charles home, from restored historic hardwood-to-tile bathroom conversions to full main-level LVP installs in new builds.",
    "Historic St. Charles homes especially benefit from our detail-heavy tile work — hex mosaics, subway wall tile, and marble-look flooring that respect the age of the home. New-build homeowners choose us for consistent, whole-home LVP or laminate installs with clean transitions and finish baseboards.",
  ],
  services: BASE_SERVICES,
  galleryImages: [
    { image: IMG_LVP_DINING, title: "Weathered-Oak LVP Dining Room", type: "LVP · St. Charles" },
    { image: IMG_TILE_HEX, title: "Hex-Tile Historic Bath", type: "Tile · St. Charles" },
    { image: IMG_MARBLE_BATH, title: "Marble-Look Primary Bath", type: "Tile · St. Charles" },
  ],
  faqs: [
    {
      q: "Do you install flooring in the City of St. Charles, MO?",
      a: "Yes — we serve every St. Charles ZIP: 63301, 63303, and 63304. From Historic Main Street bungalows to modern homes in Bogey Hills and Piper Hills, we install LVP, laminate, and tile with respect for the home's era.",
    },
    {
      q: "Do you work on historic St. Charles homes?",
      a: "Yes — historic homes are one of our specialties. We handle careful tear-out of original flooring, moisture-seal the subfloor, and install materials that suit the home's era: hex tile, subway tile, wide-plank laminate, or wood-look LVP.",
    },
    {
      q: "How much does tile installation cost in St. Charles?",
      a: "Tile labor typically runs $7–$12 per sq ft in St. Charles, plus materials. Pattern work like herringbone or hex mosaic adds 15–25%. Every quote is a transparent, line-item written estimate after a free on-site walkthrough.",
    },
  ],
};

export const CLAYTON_CONFIG = {
  slug: "clayton-mo",
  city: "Clayton",
  county: "St. Louis County",
  zips: ["63105"],
  heroKicker: "Upscale Installs · Mid-County",
  heroImage: IMG_TILE_MARBLE,
  neighborhoods: [
    "Central Clayton",
    "DeMun",
    "Hi-Pointe",
    "Wydown-Skinker",
    "Old Town Clayton",
    "North Clayton",
    "Moorlands",
    "Davis Place",
    "Brentmoor",
    "Hanley Park",
    "Claverach Park",
    "Concordia",
  ],
  localCopy: [
    "Clayton homeowners expect premium — and we deliver it. From upscale condominiums in Central Clayton to historic estates in DeMun and Wydown-Skinker, we install high-end LVP, engineered laminate, and marble-look tile with the kind of precision Clayton buyers expect.",
    "Clayton's mix of luxury high-rises and historic single-families means we frequently do full-condo LVP installs, primary-bath marble tile remodels, and kitchen-plus-mudroom tile packages. Every install includes complete tear-out, subfloor leveling, and finish baseboards — with a workmanship guarantee.",
  ],
  services: BASE_SERVICES,
  galleryImages: [
    { image: IMG_TILE_MARBLE, title: "Marble-Look Living Tile", type: "Tile · Clayton" },
    { image: IMG_MARBLE_BATH, title: "Calacatta Primary Bath", type: "Tile · Clayton" },
    { image: IMG_LVP_FIREPLACE, title: "Espresso LVP Living Room", type: "LVP · Clayton" },
  ],
  faqs: [
    {
      q: "Do you install flooring in Clayton, MO (63105)?",
      a: "Yes — we install premium LVP, laminate, and tile throughout Clayton including Central Clayton, DeMun, Wydown-Skinker, Old Town, and Moorlands.",
    },
    {
      q: "Do you handle luxury condo LVP installs in Clayton?",
      a: "Yes — condo LVP installs are common in Clayton. We coordinate building access, protect elevators and common areas, and handle tear-out and haul-away with zero disruption to neighbors.",
    },
    {
      q: "What's the best tile for a Clayton primary bathroom?",
      a: "Most Clayton homeowners prefer large-format marble-look porcelain (24×48 or 12×24) for a clean, luxury feel. We frequently pair this with herringbone shower floors and full-height wall tile.",
    },
  ],
};
